module.exports = new __parcel__URL__("kitten2.eb63dd4b.png").toString();